import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import store from '../../store';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

// Componentes de Material UI
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Container, Divider, AvatarGroup, Pagination, TextField, BottomNavigation, BottomNavigationAction, List, ListItem, ListItemText, ListItemAvatar, Autocomplete, Chip, Collapse, Box, CardActions, Paper, Grid } from '@mui/material';

// Iconos
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import hamburguesa from '../../images/hamburguesa.jpg'

// Iconos
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';

import CryptoJS from "crypto-js";

import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Tres puntos horizontales
import VisibilityIcon from '@mui/icons-material/Visibility'; // Ojo on
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'; // Ojo off
import MessageIcon from '@mui/icons-material/Message';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded'; // Para agregar contacto
import GroupIcon from '@mui/icons-material/Group';
import InfoIcon from '@mui/icons-material/Info';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import PublicIcon from '@mui/icons-material/Public';
import HttpsIcon from '@mui/icons-material/Https';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseIcon from '@mui/icons-material/Close';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import { Stack } from 'react-bootstrap';
import SidebarResponsive from '../../components/SidebarResponsive';
import { Navigate, useNavigate } from 'react-router-dom';
import { AspectRatio } from '@mui/joy';
import CateringCard from '../../components/Cards/CateringCard';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import axios, { all } from 'axios';


// Componentes de Joy UI




const mapStateToProps = (state) => {
    return {
        eventDetailsReducer: state.eventDetailsReducer,
    }
}

const Map = ({ location }) => {
    useEffect(() => {
        console.log(location)
        let map;

        const initMap = async () => {
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        console.log("Dirección encontrada:", results[0].formatted_address);
                    } else {
                        console.log("No se encontraron resultados.");
                    }
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });

            const position = { lat: location.lat, lng: location.lng };
            // const position = { lat: -32.4311892, lng: -63.72867609999999 };

            // Cargar bibliotecas de Google Maps
            const { Map } = await window.google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            map = new Map(document.getElementById('map'), {
                zoom: 15,
                center: position,
                mapId: 'DEMO_MAP_ID',
            });

            new AdvancedMarkerElement({
                map: map,
                position: position,
                title: 'Uluru',
            });
        };

        initMap();
    }, []);

    return <div id="map" style={{ height: '100%', width: '90%', marginInline: 'auto', borderRadius: 20 }}></div>;
};



function Media(props) {
    const { loading = false } = props;
    const navigate = useNavigate();




    const openEventDetails = () => {
        navigate("/eventdetails/14")
        // return <Navigate to="/createevent" />;
    }




    return (
        <Card sx={{ width: 345, m: 2 }}>
            <CardHeader
                avatar={
                    loading ? (
                        <Skeleton animation="wave" variant="circular" width={40} height={40} />
                    ) : (
                        <>
                            <Avatar
                                alt="Ted talk"
                                src={props.creatorAvatar}
                            />
                        </>
                    )
                }
                // action={
                //     loading ? null : (
                //         <IconButton aria-label="settings">
                //             <MoreVertIcon />
                //         </IconButton>
                //     )
                // }
                title={
                    loading ? (
                        <Skeleton
                            animation="wave"
                            height={10}
                            width="80%"
                            style={{ marginBottom: 6 }}
                        />
                    ) : (
                        <div style={{ display: 'flex' }}>
                            <p>{props.title}</p>
                            {props.privacity == 'Publico' ? <PublicIcon style={{ marginLeft: 16, color: '#3f51b5' }}></PublicIcon> : <HttpsIcon style={{ marginLeft: 16, color: '#ff9800' }}></HttpsIcon>}




                        </div>
                    )
                }
                subheader={
                    loading ? (
                        <Skeleton animation="wave" height={10} width="40%" style={{ marginTop: 8 }} />
                    ) : (
                        <Stack direction="row" spacing={1} style={{ marginTop: 8 }}>
                            <Chip label={props.fecha} color="primary" size="small" variant="outlined" style={{ marginRight: 4 }} />
                            •
                            <Chip label="15:30" color="success" size="small" variant="outlined"
                                style={{ marginLeft: 4 }} />
                        </Stack>
                    )
                }
            />
            {loading ? (
                <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
            ) : (
                <CardMedia
                    component="img"
                    height="140"
                    image={props.image}
                    alt="Nicola Sturgeon on a TED talk stage"
                />
            )}


            <CardContent>
                {loading ? (
                    <React.Fragment>
                        <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                        <Skeleton animation="wave" height={10} width="80%" />
                    </React.Fragment>
                ) : (
                    <Typography variant="body2" color="text.secondary" component="p">
                        {
                            props.description
                        }
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}


Media.propTypes = {
    loading: PropTypes.bool,
};






// MAIN
const JuntadaComunDetails = (props) => {
    const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const navigate = useNavigate()
    let [allUsers, setAllUsers] = useState();
    let [availableUsers, setAvailableUsers] = useState();

    let [expensas, setExpensas] = useState([])
    let [expensasChoice, setExpensasChoice] = useState(0)
    let [addExpensa, setAddExpensa] = useState(false)
    let [editExpensa, setEditExpensa] = useState(false)
    let [newExpensa, setNewExpensa] = useState({ "person": "", "amount": 0, "expense": "" })
    let [indexExpensaSelected, setIndexExpensaSelected] = useState(0)

    let [resumen, setResumen] = useState('')
    const [selectedAportadores, setSelectedAportadores] = useState([]);


    function handleAportadores(e, value) {
        console.log(value)
        setSelectedAportadores(value)
        setNewExpensa({ ...newExpensa, aportadores: value })
    }

    const handleGetDirections = () => {
        console.log(`${JSON.parse(props.eventDetailsReducer.locationCoords).lat}`)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const { latitude: userLat, longitude: userLng } = position.coords;
                const url = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${JSON.parse(props.eventDetailsReducer.locationCoords).lat},${JSON.parse(props.eventDetailsReducer.locationCoords).lng}&travelmode=driving`;
                window.open(url, '_blank');
            }, (error) => {
                console.error('Error obteniendo ubicación:', error);
                alert('No se pudo obtener tu ubicación');
            });
        } else {
            alert('La geolocalización no es soportada por tu navegador');
        }
    };

    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    function initEditExpense(index, amount, expense, aportadores) {
        setIndexExpensaSelected(index)
        setNewExpensa({ ...newExpensa, person: JSON.parse(localStorage.getItem('userData')).userID, amount: amount, expense: expense, aportadores: aportadores })
        setSelectedAportadores(aportadores)
        setEditExpensa(true);
    }

    // async function addExpense() {
    //     setExpensas([...expensas, { ...newExpensa, person: String(newExpensa.person) }]); // Agrega la nueva expensa
    //     setNewExpensa({ person: 0, amount: 0, expense: "", aportadores: [] });  // Reinicia el formulario
    //     setAddExpensa(false);  // Cierra el modal/formulario si es necesario
    //     setEditExpensa(false);
    //     setSelectedAportadores([]); // Reinicia a un array vacío


    //     console.log("expensas")
    //     console.log(JSON.stringify(expensas))
    //     await updateEvent();
    // }

    async function addExpense() {
        const updatedExpensas = [...expensas, { ...newExpensa, person: JSON.parse(localStorage.getItem('userData')).userID }]; // Agrega la nueva expensa

        setExpensas(updatedExpensas);
        setNewExpensa({ person: "", amount: 0, expense: "", aportadores: [] });  // Reinicia el formulario
        setAddExpensa(false);  // Cierra el modal/formulario si es necesario
        setEditExpensa(false);
        setSelectedAportadores([]); // Reinicia a un array vacío

        console.log("expensas actualizadas");
        console.log(JSON.stringify(updatedExpensas));

        await updateEvent(updatedExpensas); // Pasa la nueva lista de expensas directamente
    }

    async function editExpense() {
        let updatedExpensas;
        setExpensas(prevExpensas => {
            // Clonar el array original
            updatedExpensas = [...prevExpensas];

            // Modificar el objeto en la posición deseada
            updatedExpensas[indexExpensaSelected] = { ...updatedExpensas[indexExpensaSelected], ...newExpensa };

            // Actualizar el estado con el nuevo array modificado
            return updatedExpensas;
        });

        setNewExpensa({ person: "", amount: 0, expense: "", aportadores: [] });  // Reinicia el formulario
        setAddExpensa(false);  // Cierra el modal/formulario si es necesario
        setEditExpensa(false);
        setSelectedAportadores([]); // Reinicia a un array vacío

        await updateEvent(updatedExpensas);
    }

    function initDeleteExpense(index) {
        console.log(index)
        removeExpense(index);
    }

    // const removeExpense = (index) => {
    //     setExpensas(prevExpensas => prevExpensas.filter((_, i) => i !== index));
    // };

    const removeExpense = async (index) => {
        let updatedExpensas;

        setExpensas(prevExpensas => {
            updatedExpensas = prevExpensas.filter((_, i) => i !== index);
            return updatedExpensas;
        });

        // Usar un pequeño retraso para asegurarnos de que el estado se actualizó antes de llamar a updateEvent
        setTimeout(() => {
            updateEvent(updatedExpensas);
        }, 0);
    };


    const ExpenseCalculatorNet = () => {
        // Objeto para acumular el balance neto por persona.
        // La clave es el ID de la otra persona y el valor es el monto neto:
        //   - Valor positivo: esa persona te debe a vos.
        //   - Valor negativo: vos le debés a esa persona.
        const netByPerson = {};

        // Función auxiliar para guardar o actualizar el balance neto para una persona
        const updateBalance = (otherUserId, amount, name) => {
            console.log("name")
            console.log(name)
            if (netByPerson[otherUserId]) {
                netByPerson[otherUserId].balance += amount;
            } else {
                netByPerson[otherUserId] = { balance: amount, name: name };
            }
        };

        // Recorrer cada gasto para calcular el "share" y actualizar balances
        (JSON.parse(props.eventDetailsReducer.description)).forEach(expense => {
            const amount = parseFloat(expense.amount);
            const aportadores = expense.aportadores;
            const share = amount / (aportadores.length + 1);

            if (expense.person === JSON.parse(localStorage.getItem('userData')).userID) {
                // Si vos sos el comprador, cada aportador (excepto vos) te debe "share"
                aportadores.forEach(ap => {
                    if (ap.UserID !== JSON.parse(localStorage.getItem('userData')).userID) {
                        // console.log("1")
                        // console.log(ap.UserID)
                        // console.log(share)
                        // console.log(ap.NameUser)
                        updateBalance(ap.UserID, share, ap.NameUser);
                    }
                });
            } else {
                // Si vos no sos el comprador y apareces en la lista de aportadores, le debés "share" al comprador.
                const soyAportador = aportadores.some(ap => ap.UserID === JSON.parse(localStorage.getItem('userData')).userID);
                if (soyAportador) {
                    // Para el comprador, restamos el share (vos le debés)
                    // Buscamos un nombre para el comprador, en este caso podría venir de algún otro gasto
                    updateBalance(expense.person, -share, (allUsers.find(user => user.UserID === expense.person)).NameUser);
                }
            }
        });

        // Opcional: se puede calcular un balance total sumando los valores de todas las personas.
        const totalNetBalance = Object.values(netByPerson).reduce((acc, curr) => acc + curr.balance, 0);

        setResumen(netByPerson)

    };


    // async function updateEvent() {


    //     const headers = 'content-type: application/json; charset=utf-8'

    //     var userData = JSON.parse(localStorage.getItem('userData'))

    //     const data = {
    //         "eventID": props.eventDetailsReducer.eventId,
    //         "eventType": props.eventDetailsReducer.eventType,
    //         "creatorAvatar": props.eventDetailsReducer.creatorAvatar,
    //         "eventTitle": props.eventDetailsReducer.title,
    //         "creatorId": userData.userID,
    //         "guestsId": props.eventDetailsReducer.guestsId,
    //         "creatorName": props.eventDetailsReducer.creator,
    //         "eventDescription": expensas ? JSON.stringify(expensas) : "",
    //         "startDay": props.eventDetailsReducer.startDay,
    //         "startHour": props.eventDetailsReducer.startTime,
    //         "eventLocationCoords": props.eventDetailsReducer.locationCoords,
    //         "eventLocation": props.eventDetailsReducer.location,
    //         "eventPrivacity": props.eventDetailsReducer.privacity,
    //         "eventImage": props.eventDetailsReducer.image,
    //         "eventCharacteristics": props.eventDetailsReducer.caracteristics,
    //         "loginWithKey": "false"
    //     }

    //     console.log("data")
    //     console.log(data)


    //     const jsonData = JSON.stringify(data);
    //     const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    //     await axios.put('https://socializeapi.azurewebsites.net/api/UpdateEvent', { data: data_encripted }, {
    //         headers
    //     })
    //         .then(response => {
    //         })
    //         .catch(error => {
    //             console.log(`Error obteniendo datos: ${error}`);
    //             if (error == "AxiosError: Request failed with status code 401") {
    //                 navigate("/login")
    //                 alert("Sesión caducada!")
    //             }
    //         });



    // }

    async function updateEvent(expensasActualizadas) {
        const headers = { 'Content-Type': 'application/json; charset=utf-8' };
        var userData = JSON.parse(localStorage.getItem('userData'));

        const data = {
            "eventID": props.eventDetailsReducer.eventId,
            "eventType": props.eventDetailsReducer.eventType,
            "creatorAvatar": props.eventDetailsReducer.creatorAvatar,
            "eventTitle": props.eventDetailsReducer.title,
            "creatorId": props.eventDetailsReducer.creatorId,
            "guestsId": props.eventDetailsReducer.guestsId,
            "creatorName": props.eventDetailsReducer.creator,
            "eventDescription": expensasActualizadas ? JSON.stringify(expensasActualizadas) : "",
            "startDay": props.eventDetailsReducer.startDay,
            "startHour": props.eventDetailsReducer.startTime,
            "eventLocationCoords": props.eventDetailsReducer.locationCoords,
            "eventLocation": props.eventDetailsReducer.location,
            "eventPrivacity": props.eventDetailsReducer.privacity,
            "eventImage": props.eventDetailsReducer.image,
            "eventCharacteristics": props.eventDetailsReducer.caracteristics,
            "loginWithKey": "false"
        };

        console.log("data");
        console.log(data);

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        await axios.put('https://socializeapi.azurewebsites.net/api/UpdateEvent', { data: data_encripted }, { headers })
            .then(response => {
                console.log("Evento actualizado correctamente.");
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error.response && error.response.status === 401) {
                    navigate("/login");
                    alert("Sesión caducada!");
                }
            });
    }


    useEffect(() => {
        function getUsers() {
            const token = localStorage.getItem('jwt_token');

            var data = {
                loguedUser: props.eventDetailsReducer.creatorId, // aca en realidad le paso el id del creador del evento
                usersIDs: props.eventDetailsReducer.guestsId // aca le paso el id de los invotados al evento
            }


            console.log("props.eventDetailsReducer")
            console.log(props.eventDetailsReducer)

            const jsonData = JSON.stringify(data);
            const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

            const headers = 'content-type: application/json; charset=utf-8'
            axios.post(`https://socializeapi.azurewebsites.net/api/GetUsers`, { data: data_encripted }, {
                headers
            })
                .then(response => {
                    let decripted_response = decryptData(response.data)
                    let convertedToArray = JSON.parse(decripted_response)
                    console.log("convertedToArray")
                    console.log(convertedToArray)

                    // creo la lista de usuario para agregar los usuarios que deben aportar los gastos
                    let usuariosBuscador = convertedToArray.filter(item =>
                        item.UserID !== JSON.parse(localStorage.getItem("userData")).userID
                    )


                    setAvailableUsers(usuariosBuscador)

                    setAllUsers(convertedToArray)


                })
                .catch(error => {
                    console.log(`Error obteniendo datos: ${error}`);
                    if (error == "AxiosError: Request failed with status code 401") {
                        navigate("/login")
                        alert("Sesión caducada!")
                    }
                })
        }

        getUsers();
    }, []);

    useEffect(() => {
        if (props.eventDetailsReducer.description) {
            setExpensas(JSON.parse(props.eventDetailsReducer.description))

            // ExpenseCalculatorNet();
        }

        console.log(props.eventDetailsReducer.description)
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    return (
        <div>
            <Header actualPage={'eventdetails'}></Header>


            <div style={{
                display: 'flex',
                width: '100%'
            }}>


                <Container maxWidth="md">

                    {isLargeScreen ? ( // version pc
                        <>
                            {/* HEADER */}
                            <Card variant='contained' style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: 64, marginTop: 164, padding: 32, overflow: 'visible' }}>

                                {props.eventDetailsReducer.image && (

                                    <CardMedia
                                        style={{ position: 'absolute', borderRadius: '0.5rem', width: '80%', height: (isLargeScreen ? 380 : 200), top: -64 }}
                                        component="img"
                                        image={`${props.eventDetailsReducer.image}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                    />
                                )}


                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: (props.eventDetailsReducer.image ? 300 : null) }}>

                                    <Typography fontFamily="Fredoka, sans-serif" color={'grey'} variant={!isLargeScreen && props.eventDetailsReducer.title.length > 16 ? 'h4' : 'h3'} style={{ backgroundColor: 'white', top: -32, padding: "0 8px", textAlign: 'center' }} >{props.eventDetailsReducer.title}</Typography>

                                    {/* <Typography marginInline={'auto'} fontFamily="Fredoka, sans-serif" fontWeight={400} variant='h7'>{props.eventDetailsReducer.description} </Typography> */}
                                </div>


                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 16, marginTop: 36 }}>
                                    <Avatar sx={{ width: 184, height: 184 }} src={`${props.eventDetailsReducer.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}></Avatar>
                                    <Typography variant={isLargeScreen ? 'h4' : 'h6'} fontFamily="Fredoka, sans-serif" style={{ textAlign: 'center' }}>{props.eventDetailsReducer.creator}</Typography>


                                    <Typography variant='h7' style={{ fontFamily: "Fredoka, sans-serif", color: 'grey' }}>Anfitrión</Typography>
                                </div>




                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                    <AccessTimeIcon style={{ color: '#5c6bc0', fontSize: 32 }} />


                                    <div style={{ display: 'flex', gap: 8, borderRadius: '0.5rem' }}>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif">{(new Date(props.eventDetailsReducer.startDay)).toLocaleDateString("es-ES")}</Typography>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif"> - </Typography>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif">{props.eventDetailsReducer.startTime}hs</Typography>
                                    </div>
                                </div>

                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, borderRadius: '0.5rem', marginTop: 16 }}>
                                    <LocationOnIcon style={{ color: '#5c6bc0', fontSize: 32 }} />
                                    {(props.eventDetailsReducer.location != "" && props.eventDetailsReducer.location != null) ? (

                                        <>
                                            <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif">{props.eventDetailsReducer.location}</Typography>
                                            <Button
                                                variant='contained'
                                                onClick={handleGetDirections}
                                                style={{ padding: '10px 20px', marginBottom: 8, borderRadius: 60 }}
                                            >
                                                ¿Cómo llegar?
                                            </Button>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', height: 300 }}>

                                                <Map location={JSON.parse(props.eventDetailsReducer.locationCoords)}></Map>
                                            </div>
                                        </>



                                    ) : (
                                        <Typography variant='h6' fontWeight={400} color={'grey'} fontFamily="Fredoka, sans-serif">Ubicación no especificada.</Typography>
                                    )}
                                </div>


                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 24 }}>
                                    <InfoIcon style={{ color: '#5c6bc0', fontSize: 32 }} />
                                    {/* <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif" marginTop={1}>Detalles del evento</Typography> */}


                                </div>

                                {props.eventDetailsReducer.caracteristics != "" && props.eventDetailsReducer.caracteristics != null ? (

                                    <div style={{ backgroundColor: '#f0f0f0', marginTop: 16, width: '100%', borderRadius: 4, padding: 8 }}>
                                        <text style={{ whiteSpace: 'pre-wrap', fontFamily: 'Fredoka, sans-serif' }}>{props.eventDetailsReducer.caracteristics}</text>
                                        {/* <TextField variant='filled' multiline value={props.eventDetailsReducer.caracteristics} disabled fullWidth style={{ borderWidth: 0 }}></TextField> */}
                                    </div>
                                ) : (
                                    <Typography variant='h6' fontWeight={400} color={'grey'} fontFamily="Fredoka, sans-serif">No se proporcionó información importante</Typography>
                                )}

                                <Card style={{ width: '100%', marginTop: 32 }}>

                                    <BottomNavigation
                                        showLabels
                                        value={expensasChoice}
                                        onChange={(value, newValue) => {
                                            setExpensasChoice(newValue); ExpenseCalculatorNet()
                                        }}
                                    >
                                        <BottomNavigationAction label="Tus Gastos" icon={<AddShoppingCartRoundedIcon />} />
                                        <BottomNavigationAction label="Todos los gastos" icon={<PaymentsRoundedIcon />} />
                                        <BottomNavigationAction label="Resumen" icon={<TaskAltRoundedIcon />} />
                                    </BottomNavigation>
                                </Card>

                                <div style={{ width: '100%', height: 600, marginTop: 16 }}>
                                    {expensasChoice == 0 && (
                                        <>
                                            {(!addExpensa || !editExpensa) && (
                                                <Button style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                                                    onClick={() => {
                                                        setAddExpensa(true)
                                                        // setNewExpensa({ ...newExpensa, person: JSON.parse(localStorage.getItem('userData')).userID });
                                                    }}>
                                                    <AddRoundedIcon></AddRoundedIcon>
                                                    Agregar Compra
                                                </Button>
                                            )}

                                            {(addExpensa || editExpensa) && (
                                                <Card>

                                                    <List dense={false} style={{ width: '100%', marginInline: 'auto' }}>
                                                        <ListItem
                                                            secondaryAction={
                                                                newExpensa.amount && newExpensa.expense ? (
                                                                    <>
                                                                        {addExpensa && (
                                                                            <Button color='success' edge="end" onClick={addExpense}>
                                                                                agregar
                                                                                {/* <CloseIcon color='error' /> */}
                                                                            </Button>

                                                                        )}

                                                                        {editExpensa && (
                                                                            <Button color='success' edge="end"
                                                                                onClick={editExpense}>
                                                                                editar
                                                                                {/* <CloseIcon color='error' /> */}
                                                                            </Button>

                                                                        )}

                                                                        <Button color='error' edge="end"
                                                                            onClick={() => {
                                                                                setAddExpensa(false);
                                                                                setEditExpensa(false);
                                                                                setNewExpensa({ person: "", amount: 0, expense: "", aportadores: [] });  // Reinicia el formulario
                                                                                setSelectedAportadores([]); // Reinicia a un array vacío
                                                                            }}>
                                                                            cancelar
                                                                            {/* <CloseIcon color='error' /> */}
                                                                        </Button>
                                                                    </>
                                                                ) : (

                                                                    <Button color='error' edge="end"
                                                                        onClick={() => {
                                                                            setAddExpensa(false);
                                                                            setEditExpensa(false);
                                                                            setNewExpensa({ person: "", amount: 0, expense: "", aportadores: [] });  // Reinicia el formulario
                                                                            setSelectedAportadores([]); // Reinicia a un array vacío
                                                                        }}>
                                                                        cancelar
                                                                        {/* <CloseIcon color='error' /> */}
                                                                    </Button>
                                                                )
                                                            }
                                                        >
                                                            <ListItemText
                                                                primary={
                                                                    <>
                                                                        <TextField size='small' placeholder='Compra' style={{ width: 140, marginRight: 8, float: 'left' }}
                                                                            value={newExpensa.expense}
                                                                            onChange={(e) => setNewExpensa({ ...newExpensa, expense: e.target.value })}
                                                                        ></TextField>
                                                                        <TextField type='number' size='small' placeholder='Costo' style={{ width: 140, marginRight: 8, float: 'left' }}
                                                                            value={newExpensa.amount}
                                                                            onChange={(e) => setNewExpensa({ ...newExpensa, amount: e.target.value })}
                                                                        ></TextField>
                                                                        <Autocomplete
                                                                            size='small'
                                                                            style={{ width: 240, float: 'left' }}
                                                                            multiple
                                                                            id="tags-outlined"
                                                                            value={selectedAportadores} // Aquí se asigna el estado
                                                                            onChange={handleAportadores}
                                                                            options={availableUsers}  // Se usa el array completo
                                                                            getOptionLabel={(option) => option.NameUser}  // Extrae correctamente el nombre de la persona
                                                                            filterSelectedOptions
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    placeholder="Quién debe aportar?"
                                                                                />
                                                                            )}
                                                                        />
                                                                    </>
                                                                }
                                                            />
                                                        </ListItem>
                                                    </List>
                                                </Card>

                                            )}
                                            <List dense={false} style={{ width: '100%', marginInline: 'auto' }}>
                                                {expensas.map(({ person, amount, expense, aportadores }, index) => (
                                                    person == JSON.parse(localStorage.getItem('userData')).userID && (
                                                        <>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <>
                                                                        <IconButton edge="end" onClick={() => { initEditExpense(index, amount, expense, aportadores) }}>
                                                                            <EditRoundedIcon color='warning' />
                                                                        </IconButton>
                                                                        <IconButton edge="end" style={{ marginLeft: 16 }} onClick={() => { initDeleteExpense(index) }}>
                                                                            <CloseIcon color='error' />
                                                                        </IconButton>
                                                                    </>
                                                                }
                                                            >
                                                                <ListItemText
                                                                    style={{ maxWidth: '30%' }}
                                                                    primary={expense}
                                                                    secondary={`$${amount}`}
                                                                />
                                                                {aportadores && (

                                                                    <div style={{ maxWidth: '60%', marginLeft: 0, marginRight: 60 }}>
                                                                        {
                                                                            aportadores.map((item, index) => (
                                                                                <Chip color='success' key={index} label={item.NameUser} style={{ margin: 4 }} />
                                                                            ))
                                                                        }
                                                                    </div>
                                                                    // <ListItemText
                                                                    //     primary={

                                                                    //     }
                                                                    // />
                                                                )}
                                                                {/* <Typography style={{backgroundColor: 'red', float: 'left'}}>geadfdsfdsaf df dsaf ase</Typography> */}
                                                            </ListItem>
                                                            <Divider variant="fullWidth" component="li" />
                                                        </>
                                                    )
                                                ))}
                                            </List>
                                        </>
                                    )}

                                    {expensasChoice == 1 && (
                                        <List dense={false} style={{ width: '100%', marginInline: 'auto' }}>
                                            {expensas.map(({ person, amount, expense, aportadores }, index) => (
                                                (person == JSON.parse(localStorage.getItem('userData')).userID || JSON.stringify(aportadores).includes(`${JSON.parse(localStorage.getItem('userData')).userID}`)) && (
                                                    <>
                                                        <ListItem>
                                                            <ListItemText
                                                                style={{ maxWidth: '30%' }}
                                                            >
                                                                <Chip variant="outlined" label={(allUsers.find(user => user.UserID === person)).NameUser} color="success" />
                                                            </ListItemText>
                                                            <ListItemText
                                                                style={{ maxWidth: '60%' }}
                                                                primary={expense}
                                                            />
                                                            <ListItemText style={{ textAlign: 'end' }}>
                                                                <Chip
                                                                    label={person !== JSON.parse(localStorage.getItem('userData')).userID ? `-$${amount}` : `$${amount}`}
                                                                    color={person !== JSON.parse(localStorage.getItem('userData')).userID ? "error" : "success"} />
                                                            </ListItemText>
                                                            {/* <Typography style={{backgroundColor: 'red', float: 'left'}}>geadfdsfdsaf df dsaf ase</Typography> */}
                                                        </ListItem>
                                                        <Divider variant="fullWidth" component="li" />
                                                    </>
                                                )
                                            ))}
                                        </List>
                                    )}

                                    {expensasChoice === 2 && (
                                        <Box sx={{ width: '100%', mt: 2 }}>
                                            {Object.entries(resumen).map(([userId, data]) => (
                                                <Card
                                                    key={userId}
                                                    sx={{
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                        boxShadow: 3
                                                    }}
                                                >
                                                    {/* <CardActions>
                                                            <Button
                                                                size="small"
                                                                color="primary"
                                                                onClick={() => {
                                                                    const element = document.getElementById(`details-${userId}`);
                                                                    element.style.display = element.style.display === 'none' ? 'block' : 'none';
                                                                }}
                                                            >
                                                                Ver detalles
                                                            </Button>
                                                        </CardActions>
                                                    </Box>
                                                    
                                                    <Box id={`details-${userId}`}  */}
                                                    <Box sx={{
                                                        p: 2,
                                                        background: data.balance > 0 ? 'linear-gradient(45deg, #4caf50 30%, #81c784 90%)' :
                                                            'linear-gradient(45deg, #f44336 30%, #e57373 90%)',
                                                        color: 'white',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => {
                                                        const element = document.getElementById(`details-${userId}`);
                                                        element.style.display = element.style.display === 'none' ? 'block' : 'none';
                                                    }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                            <Avatar sx={{
                                                                width: 56,
                                                                height: 56,
                                                                bgcolor: 'white',
                                                                color: data.balance > 0 ? '#4caf50' : '#f44336'
                                                            }}>
                                                                {data.balance > 0 ? <ArrowUpwardIcon fontSize="large" /> : <ArrowDownwardIcon fontSize="large" />}
                                                            </Avatar>
                                                            <Box>
                                                                <Typography fontFamily="Fredoka, sans-serif" variant="h5" sx={{ fontWeight: 500 }}>
                                                                    {data.name}
                                                                </Typography>
                                                                <Typography variant="h8" fontFamily="Fredoka, sans-serif">
                                                                    {data.balance > 0 ? 'Te debe' : 'Le debes'}: ${Math.abs(data.balance).toFixed(2)}
                                                                </Typography>
                                                            </Box>


                                                            {/* <CardHeader
                                                            avatar={
                                                                <Avatar sx={{ bgcolor: data.balance > 0 ? '#4caf50' : '#f44336' }}>
                                                                    {data.balance > 0 ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                                                                </Avatar>
                                                            }
                                                            title={data.name}
                                                            subheader={
                                                                <Typography variant="body2" color={data.balance > 0 ? 'success.main' : 'error.main'}>
                                                                    {data.balance > 0 ? 'Te debe' : 'Le debes'}: ${Math.abs(data.balance).toFixed(2)}
                                                                </Typography>
                                                            }
                                                        /> */}
                                                        </Box>
                                                    </Box>

                                                    <Box id={`details-${userId}`} style={{display: 'none'}} sx={{ p: 3, bgcolor: 'background.paper' }}>
                                                        <Typography variant="h6" sx={{ mb: 3, color: 'text.primary', fontWeight: 500 }}>
                                                            Desglose de gastos
                                                        </Typography>

                                                        {expensas.map((expense, index) => {
                                                            const share = expense.amount / (expense.aportadores.length + 1);

                                                            if (expense.person == userId) {
                                                                return (
                                                                    <Card
                                                                        key={index}
                                                                        sx={{
                                                                            mb: 2,
                                                                            p: 2,
                                                                            borderLeft: '4px solid #f44336',
                                                                            boxShadow: 1
                                                                        }}
                                                                    >
                                                                        <Stack spacing={2}>
                                                                            <Typography variant="h6" color="error.main">
                                                                                {expense.expense}
                                                                            </Typography>
                                                                            <Grid container spacing={2}>
                                                                                <Grid item xs={6}>
                                                                                    <Typography variant="body2" color="text.secondary">
                                                                                        Gasto total
                                                                                    </Typography>
                                                                                    <Chip
                                                                                        label={`$${expense.amount}`}
                                                                                        color="primary"
                                                                                        sx={{ mt: 1 }}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={6}>
                                                                                    <Typography variant="body2" color="text.secondary">
                                                                                        Dividido entre
                                                                                    </Typography>
                                                                                    <Chip
                                                                                        label={`${expense.aportadores.length + 1} personas`}
                                                                                        color="info"
                                                                                        sx={{ mt: 1 }}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                            <Box sx={{
                                                                                mt: 1,
                                                                                p: 1,
                                                                                borderRadius: 1,
                                                                                bgcolor: 'error.light',
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Typography variant="subtitle1" color="white">
                                                                                    Le debes
                                                                                </Typography>
                                                                                <Typography variant="h6" color="white">
                                                                                    ${share.toFixed(2)}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Card>
                                                                );
                                                            } else if (expense.aportadores.some(ap => ap.UserID == userId) && expense.person == JSON.parse(localStorage.getItem('userData')).userID) {
                                                                return (
                                                                    <Card
                                                                        key={index}
                                                                        sx={{
                                                                            mb: 2,
                                                                            p: 2,
                                                                            borderLeft: '4px solid #4caf50',
                                                                            boxShadow: 1
                                                                        }}
                                                                    >
                                                                        <Stack spacing={2}>
                                                                            <Typography variant="h6" color="primary.main">
                                                                                {expense.expense}
                                                                            </Typography>
                                                                            <Box sx={{
                                                                                p: 1,
                                                                                bgcolor: 'success.light',
                                                                                borderRadius: 1,
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <Typography variant="subtitle1" color="white">
                                                                                    Te debe
                                                                                </Typography>
                                                                                <Typography variant="h6" color="white">
                                                                                    ${share.toFixed(2)}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Card>
                                                                );
                                                            }
                                                            return null;
                                                        })}
                                                    </Box>
                                                </Card>
                                            ))}
                                        </Box>
                                    )}


                                </div>



                            </Card>
                        </>
                    ) : ( // version movil
                        <>
                            {/* HEADER */}
                            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: 64, marginTop: 164, overflow: 'visible' }}>

                                {props.eventDetailsReducer.image && (
                                    <CardMedia
                                        style={{ position: 'absolute', borderRadius: '0.5rem', width: '100%', height: '30vh', top: -64, objectFit: 'cover' }}
                                        component="img"
                                        image={`${props.eventDetailsReducer.image}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                    />
                                )}


                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: (props.eventDetailsReducer.image ? 180 : null) }}>

                                    <Typography fontFamily="Fredoka, sans-serif" color={'grey'} variant={'h4'} style={{ backgroundColor: 'white', padding: "0 8px", textAlign: 'center' }} >{props.eventDetailsReducer.title}</Typography>

                                    <Typography marginInline={'auto'} fontFamily="Fredoka, sans-serif" fontWeight={400} variant='h7' textAlign={'center'}>{props.eventDetailsReducer.description} </Typography>
                                </div>


                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 16, marginTop: 36 }}>
                                    <Avatar sx={{ width: 128, height: 128 }} src={`${props.eventDetailsReducer.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}></Avatar>
                                    <Typography variant={isLargeScreen ? 'h4' : 'h6'} fontFamily="Fredoka, sans-serif" style={{ textAlign: 'center' }}>{props.eventDetailsReducer.creator}</Typography>


                                    <Typography variant='h7' style={{ fontFamily: "Fredoka, sans-serif", color: 'grey' }}>Anfitrión</Typography>
                                </div>




                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                    <AccessTimeIcon style={{ color: '#5c6bc0', fontSize: 32 }} />


                                    <div style={{ display: 'flex', gap: 8, borderRadius: '0.5rem' }}>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif">{(new Date(props.eventDetailsReducer.startDay)).toLocaleDateString("es-ES")}</Typography>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif"> - </Typography>
                                        <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif">{props.eventDetailsReducer.startTime}hs</Typography>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, borderRadius: '0.5rem', marginTop: 32, width: '100%', textAlign: 'center' }}>
                                    <LocationOnIcon style={{ color: '#5c6bc0', fontSize: 32 }} />
                                    {(props.eventDetailsReducer.location != "" && props.eventDetailsReducer.location != null) ? (

                                        <>
                                            <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif" style={{ marginInline: 'auto' }}>{props.eventDetailsReducer.location}</Typography>

                                            <Button
                                                variant='contained'
                                                onClick={handleGetDirections}
                                                style={{ padding: '10px 20px', margin: '20px', borderRadius: 60 }}
                                            >
                                                ¿Cómo llegar?
                                            </Button>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', height: 200 }}>

                                                <Map location={JSON.parse(props.eventDetailsReducer.locationCoords)}></Map>
                                            </div>
                                        </>

                                    ) : (
                                        <Typography variant='h6' fontWeight={400} color={'grey'} fontFamily="Fredoka, sans-serif">Ubicación no especificada.</Typography>
                                    )}
                                </div>




                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 24 }}>
                                    <InfoIcon style={{ color: '#5c6bc0', fontSize: 32 }} />
                                    {/* <Typography variant='h6' fontWeight={400} fontFamily="Fredoka, sans-serif" marginTop={1}>Detalles del evento</Typography> */}


                                </div>

                                {props.eventDetailsReducer.caracteristics != "" && props.eventDetailsReducer.caracteristics != null ? (

                                    <div style={{ backgroundColor: '#f0f0f0', marginTop: 16, width: '100%', borderRadius: 4, padding: 8 }}>
                                        <text style={{ whiteSpace: 'pre-wrap', fontFamily: 'Fredoka, sans-serif' }}>{props.eventDetailsReducer.caracteristics}</text>
                                        {/* <TextField variant='filled' multiline value={props.eventDetailsReducer.caracteristics} disabled fullWidth style={{ borderWidth: 0 }}></TextField> */}
                                    </div>
                                ) : (
                                    <Typography variant='h6' fontWeight={400} color={'grey'} fontFamily="Fredoka, sans-serif">No se han proporcionado detalles</Typography>
                                )}


                                <Card style={{ width: '100%', marginTop: 32 }}>

                                    <BottomNavigation
                                        showLabels
                                        value={expensasChoice}
                                        onChange={(value, newValue) => {
                                            setExpensasChoice(newValue);
                                        }}
                                    >
                                        <BottomNavigationAction label="Tus Gastos" icon={<AddShoppingCartRoundedIcon />} />
                                        <BottomNavigationAction label="Todos los gastos" icon={<PaymentsRoundedIcon />} />
                                    </BottomNavigation>
                                </Card>

                                <div style={{ width: '100%', height: 600, marginTop: 16 }}>
                                    {expensasChoice == 0 && (
                                        <>
                                            {!addExpensa || !editExpensa && (
                                                <Button style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                                                    onClick={() => {
                                                        setAddExpensa(true);
                                                        setNewExpensa({ person: "", amount: 0, expense: "", aportadores: null });  // Reinicia el formulario
                                                    }}>
                                                    <AddRoundedIcon></AddRoundedIcon>
                                                    Agregar Compra
                                                </Button>
                                            )}

                                            {addExpensa || !editExpensa && (
                                                <Card style={{ display: 'flex', flexDirection: 'column', padding: 32, gap: 16 }}>

                                                    <TextField size='small' placeholder='Compra' style={{ width: '100%' }}
                                                        value={newExpensa.expense}
                                                        onChange={(e) => setNewExpensa({ ...newExpensa, expense: e.target.value })}
                                                    ></TextField>
                                                    <TextField type='number' size='small' placeholder='Costo' style={{ width: '100%', marginRight: 8 }}></TextField>
                                                    <Autocomplete
                                                        size='small'
                                                        style={{ width: '100%' }}
                                                        multiple
                                                        id="tags-outlined"
                                                        value={selectedAportadores} // Asigna el estado
                                                        options={expensas}  // Se usa el array completo
                                                        getOptionLabel={(option) => option.person}  // Extrae correctamente el nombre de la persona
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Quién debe aportar?"
                                                            />
                                                        )}
                                                    />

                                                    <Button color='error' edge="end" onClick={() => { setAddExpensa(false) }}>
                                                        cancelar
                                                        {/* <CloseIcon color='error' /> */}
                                                    </Button>
                                                </Card>

                                            )}

                                            <List dense={false} style={{ width: '100%', marginInline: 'auto' }}>
                                                {expensas.map(({ person, amount, expense }, index) => (
                                                    // <ListItem>
                                                    //     <ListItemAvatar>
                                                    //         <Avatar alt="Profile Picture" src={person} />
                                                    //     </ListItemAvatar>
                                                    //     <ListItemText primary={primary} secondary={secondary} />
                                                    // </ListItem>
                                                    <>
                                                        <ListItem
                                                            secondaryAction={
                                                                <IconButton edge="end">
                                                                    <CloseIcon color='error' />
                                                                </IconButton>
                                                            }
                                                        >
                                                            <ListItemText
                                                                primary={expense}
                                                                secondary={`${amount}$`}
                                                            />
                                                        </ListItem>
                                                        <Divider variant="fullWidth" component="li" />
                                                    </>
                                                ))}
                                            </List>
                                        </>
                                    )}
                                </div>

                            </div>
                        </>
                    )}















                </Container>




            </div>


        </div>
    )


}


export default connect(mapStateToProps)(JuntadaComunDetails);



